/** Max characters for ticket subject on all create/edit forms. */
export const SUBJECT_MAX_LENGTH = 100;

export function clampTicketSubject(value: string): string {
  return value.length <= SUBJECT_MAX_LENGTH
    ? value
    : value.slice(0, SUBJECT_MAX_LENGTH);
}

export function subjectMaxLengthError(): string {
  return `Subject must be ${SUBJECT_MAX_LENGTH} characters or less.`;
}
